import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ArrowUpIcon } from '../../utils/IconWrapper';

const ButtonContainer = styled.button<{ $visible: boolean }>`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--bg-secondary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition: all 0.3s ease;
  z-index: 999;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateY(-5px);
  }
`;

const BackToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Controlla lo scroll e mostra il pulsante solo quando necessario
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    
    window.addEventListener('scroll', toggleVisibility);
    
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  
  // Funzione per tornare all'inizio della pagina
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <ButtonContainer 
      $visible={isVisible} 
      onClick={scrollToTop} 
      aria-label="Torna all'inizio della pagina"
    >
      <ArrowUpIcon />
    </ButtonContainer>
  );
};

export default BackToTopButton; 